import { Grid, TextField } from "@mui/material";
import React from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";

import { Container, Input } from "./styles";
import { intlFormatDateShort } from "../../../../utils/time-utils";

const EmployeeMutationInput = ({ originalValue, mutationValue, handleChangeMutation, field }) => {
  const { i18n, t } = useTranslation();
  const tRP = "components.data_and_documents"; // tRP - translation root path

  return (
    <Container>
      <Input
        disabled
        label={`${t(`${tRP}.common_keys.original`)} ${t(`${tRP}.my_data_and_documents.employee.fields.${field}`)}`}
        value={field === "birthDate" ? intlFormatDateShort(originalValue) : originalValue ?? ""}
      />
      {field === "birthDate" ? (
        <Grid>
          <DatePicker
            selected={mutationValue ? new Date(mutationValue) : new Date()}
            onChange={(date) => {
              // convert whe date value to compensate UTC offset
              const theDate = date as Date;
              const offsetMiliseconds = theDate.getTimezoneOffset() * 60000;
              const value = new Date(theDate.getTime() - offsetMiliseconds);
              handleChangeMutation(field, value);
            }}
            locale={i18n.language}
            customInput={
              <TextField
                variant="outlined"
                label={`${t(`${tRP}.common_keys.new`)} ${t(`${tRP}.my_data_and_documents.employee.fields.${field}`)}`}
              />
            }
            dateFormat="yyyy-MM-dd"
            popperPlacement="top"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
          />
        </Grid>
      ) : (
        <Input
          label={`${t(`${tRP}.common_keys.new`)} ${t(`${tRP}.my_data_and_documents.employee.fields.${field}`)}`}
          value={mutationValue ?? ""}
          onChange={(e) => handleChangeMutation(field, e.target.value)}
        />
      )}
    </Container>
  );
};

export default EmployeeMutationInput;
